import { render, staticRenderFns } from "./IconTooltipMessage.vue?vue&type=template&id=01d97534&scoped=true"
import script from "./IconTooltipMessage.vue?vue&type=script&lang=js"
export * from "./IconTooltipMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d97534",
  null
  
)

export default component.exports